import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { SectionHead } from '../components/section-head'
import { AssetImage } from '../components/image'
import { pageMaxWidth } from '../styles/page-max-width'

const Outer = styled.div`
  ${pageMaxWidth}
  padding-top: 4rem;
  @media (width <= 60rem){
    padding-top: 2rem;
  }
`

const HeadContainer = styled.div`
`

const Inner = styled.div`
display: grid;
grid-template-columns: auto auto;
gap: 5.5rem;
padding-inline: var(--page-margin);
margin-top: 5rem;
  @media (max-width: 60rem){
   grid-template-columns: 1fr; 
   padding-inline: 0;
   margin-top: 3rem;
   gap: 2rem;
  }
`

const products: ProductData[] = [
  {
    id: 'TF0001_SCGT_F_na',
    image: 'pl1.png',
    label: '機能性表示食品',
    nameEn: 'SLIM CLEANSE GREEN TEA',
    nameJa: 'フレッシュグリーンの香り',
    tags: [
      '内臓脂肪<sup>※</sup>',
      'お通じ'
    ],
    note: `
      ※本品には3-(4-ヒドロキシ-3-メトキシフェニル)プロピオン酸(HMPA)、植物性乳酸菌K-1（L. casei 327）が含まれます。HMPAには、BMIが高めの方の腹部の脂肪(内臓脂肪)とウエスト周囲径を減らす機能が報告されています。植物性乳酸菌K-1（L. casei 327）には、お腹の調子を整えお通じを改善する機能があることが報告されています。<br>
      ※対象：BMI25～30未満
    `
  },
  {
    id: 'TF0003_SNPRT_F_na',
    image: 'pl2.png',
    label: '機能性表示食品',
    nameEn: 'SLEEP NIGHT PEACH ROOIBOS TEA',
    nameJa: 'メロウピーチの香り',
    tags: [
      '睡眠<sup>※</sup>',
      '肌の弾力の維持'
    ],
    note: `
      ※本品にはGABAが含まれています。GABAには、一時的な疲労感やストレスを感じている方の睡眠の質（眠りの深さ）の向上に役立つ機能、肌の乾燥が気になる方の肌の弾力を維持し、肌の健康を守るのを助ける機能が報告されています。
    `
  },
  {
    id: 'TF0300_SCYK_F_na',
    image: 'pl7.png',
    label: '',
    nameEn: 'SLIM CLEANSE YOKAN',
    nameJa: 'こしあん味',
    tags: [
      '食物繊維5000mg',
      '乳酸菌100億個',
      '腸活に嬉しい<sup>※1</sup>',
      'ロカボ',
      '糖質49%オフ<sup>※2</sup>',
      '脂質ゼロ',
    ],
    note: `
      ※1 成分を腸に届けること<br>
      ※2 日本食品標準成分表2020年版〈八訂〉 ようかんとの比較
    `
  },
  {
    id: 'TF0301_SCYB_F_na',
    image: 'pl8.png',
    label: '',
    nameEn: 'SLIM CLEANSE YOKAN',
    nameJa: 'ベリー味',
    tags: [
      '食物繊維5000mg',
      '乳酸菌100億個',
      '腸活に嬉しい<sup>※1</sup>',
      'ロカボ',
      '糖質47%オフ<sup>※2</sup>',
      '脂質ゼロ',
    ],
    note: `
      ※1 成分を腸に届けること<br>
      ※2 日本食品標準成分表2020年版〈八訂〉 ようかんとの比較
    `
  }
]

type ProductsSectionProps = {

}
export const ProductsSection: FunctionComponent<ProductsSectionProps> = () => {
  return <Outer>
    <HeadContainer>
      <SectionHead en="PRODUCTS" ja="商品一覧"/>
    </HeadContainer>
    <Inner>
      {
        products.map(product => <ProductItem product={product} />)
      }
    </Inner>
  </Outer>
}

const ItemOuter = styled.a`
  display: block;
  font-family: var(--sans-serif-font);
  padding: 4rem;
  background-color: var(--pale-beige);
  color: var(--dark-brown);
  transition: background-color 0.4s;
  &:hover {
    background-color: color-mix(in srgb, var(--pale-beige) 50%, white);
  }
  @media (max-width: 80rem){
    padding: 3rem;
  }
  @media (max-width: 60rem){
    padding: 2rem;
  }
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 60rem){
    
  }
  img {
    display: block;
    width: 100%;
    max-width: min(20rem, 80%);
    @media (max-width: 60rem){
      
    }
  }
`

const Label = styled.div`
font-size: 0.9375rem;
padding: 0.25rem 0.625rem;
border: 1px solid currentColor;
width: fit-content;
margin-top: 5rem;
@media (max-width: 60rem){
  font-size: 0.875rem;
  margin-top: 2rem;
}
`

const Name = styled.div`
font-size: 1.4375rem;
line-height: 1.5;
letter-spacing: 0.05em;
margin-top: 0.8125rem;
@media (max-width: 60rem){
  font-size: 1.25rem;
}
`

const NameJa = styled.div`
font-size: 1.25rem;
line-height: 1.5;
letter-spacing: 0.05em;
font-weight: 300;
margin-top: -0.25rem;
@media (max-width: 60rem){
  font-size: 1rem;
  margin-top: 0;
}
`

const TagContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.125rem;
  margin-top: 1.5rem;
  @media (max-width: 60rem){
    margin-top: 1rem;
  }
`

const Tag = styled.div`
font-size: 0.84375rem;
letter-spacing: 0.2em;
text-align: center;
padding: 0.5rem;
background-color: #E9E3E0;
border-radius: 100rem;
font-weight: 600;
@media (max-width: 60rem){
  padding-inline: 0;
}
`

const Note = styled.div`
font-size: 0.65rem;
line-height: 1.5;
letter-spacing: 0.05em;
font-weight: 300;
margin-top: 1.5rem;
opacity: 0.75;
@media (max-width: 60rem){
  
}
`

type ProductData = {
  id: string
  image: string,
  label: string,
  nameEn: string,
  nameJa: string,
  tags: string[],
  note: string
}
type ProductItemProps = {
  product: ProductData
}
export const ProductItem: FunctionComponent<ProductItemProps> = ({product}) => {
  return <ItemOuter href={`https://stoked-store.jp/shop/products/${product.id}`}>
    <ImageContainer>
      <AssetImage src={product.image} />
    </ImageContainer>
    {product.label && <Label dangerouslySetInnerHTML={{__html: product.label}} />}
    <Name dangerouslySetInnerHTML={{__html: product.nameEn}} />
    <NameJa dangerouslySetInnerHTML={{__html: product.nameJa}} />
    <TagContainer>
      {
        product.tags.map(tag => <Tag dangerouslySetInnerHTML={{__html:tag}} />)
      }
    </TagContainer>
    <Note dangerouslySetInnerHTML={{__html:product.note}} />
  </ItemOuter>
}